import { addHook } from '@viveaesthetics/elemy-shared-core'
import { atom, useAtom } from 'jotai'

const userDataAtom = atom({
  email: ''
})

export const useUserData = addHook({
  useUserData: () => useAtom(userDataAtom)
})
